import { IoIosCheckmarkCircle } from 'react-icons/io';
import { IoMdCloseCircle } from 'react-icons/io';
import { RxCalendar } from 'react-icons/rx';

export const getValueIcon = (fieldName: string, value?: string | null) => {
    if (value === 'true') {
        return <IoIosCheckmarkCircle />;
    } else if (value === 'false') {
        return <IoMdCloseCircle />;
    } else if (fieldName === 'Settlement Date' || fieldName === 'Date') {
        return <RxCalendar />;
    } else return null;
};
